<template>
  <div class="card-body bg-light">
    <h5 class="text-left">
      {{ formTitle }}
    </h5>

    <form class="form">
      <ReadOnlyField
        :value="item[displayFieldName]"
        :fieldName="itemType"
        :displayLabel="true"
      />
      <TextField
        fieldName="External ID"
        v-model="externalId"
        :displayLabel="true"
        placeholderText="Enter external ID"
        fieldDescription="External identifier for this manual deposit"
      />
      <NotesField v-model="notes" />
      <SubmitButton
        :buttonText="formTitle"
        :loading="loading"
        @submit="emitForm"
      />
    </form>
  </div>
</template>

<script>
import TextField from "@/components/formFieldComponents/TextField.vue";
import NotesField from "@/components/formFieldComponents/NotesField.vue";
import ReadOnlyField from "@/components/formFieldComponents/ReadOnlyField.vue";
import SubmitButton from "@/components/formFieldComponents/SubmitButton.vue";

export default {
  name: "ManualTrackerDeposit",
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    item: Object,
    itemType: String,
    displayFieldName: String,
  },
  data() {
    return {
      externalId: "",
      notes: "",
    };
  },
  methods: {
    emitForm() {
      this.$emit("form-submission", {
        external_id: this.externalId,
        notes: this.notes,
      });
    },
  },
  components: {
    TextField,
    NotesField,
    ReadOnlyField,
    SubmitButton,
  },
};
</script>

<style scoped></style>
